<mat-card>
  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <h3 class="page-header">Settings</h3>
  </mat-card-title>
  <mat-card-content>
    <mat-tab-group [(selectedIndex)]="selectedTabIndex">
      <mat-tab label="Settings">
        <app-client-settings [settings]="clientSettings"></app-client-settings>
      </mat-tab>
      <mat-tab label="Email">
        <app-client-email-config [settings]="clientSettings"></app-client-email-config>
      </mat-tab>
      <mat-tab label="Email Alert">
        <app-email-settings [settings]="clientSettings"
          (immediateSettingsReady)="onImmediateSettingsReady($event)"></app-email-settings>
      </mat-tab>
      <mat-tab label="AI Policy">
        <app-ai-policy [settings]="clientSettings"></app-ai-policy>
      </mat-tab>
      <mat-tab label="SSO" *ngIf="isSurvaleAdmin">
        <app-sso-settings [settings]="clientSettings"></app-sso-settings>
      </mat-tab>
      <mat-tab label="Security">
        <app-client-ip-white-list [settings]="clientSettings" [useIpWhiteList]="useIpWhiteList"
          [clientAPIKeys]="clientAPIKeys" [ipWhiteList]="ipWhiteList">
        </app-client-ip-white-list>
      </mat-tab>
      <mat-tab label="HM Portal Custom Fields">
        <app-hm-portal-custom-fields [settings]="clientSettings"></app-hm-portal-custom-fields>
      </mat-tab>
      <mat-tab label="Other" *ngIf="isSurvaleAdmin">
        <app-other-client-settings [settings]="clientSettings"></app-other-client-settings>
      </mat-tab>
      <mat-tab label="Classification">
        <app-client-classification [settings]="clientSettings"></app-client-classification>
      </mat-tab>
      <mat-tab label="Index Weights">
        <app-client-index-weights [settings]="clientSettings"></app-client-index-weights>
      </mat-tab>
      <mat-tab label="Question Sets">
        <app-question-sets [settings]="clientSettings"></app-question-sets>
      </mat-tab>
    </mat-tab-group>
    <hr />
    <mat-card-actions class="float-right">

      <button mat-raised-button class="mat-green action-btn" *ngIf="isSurvaleAdmin && currentUser.parentClientIds === '-1'"
        (click)="showAddClient()">Add client
      </button>

      <button mat-raised-button class="mat-primary action-btn" (click)="saveSettings()">Save Settings</button>

    </mat-card-actions>
    <p>&nbsp;</p>
  </mat-card-content>
</mat-card>
